import { render, staticRenderFns } from "./UserAssessmentModal2.vue?vue&type=template&id=f3295fa6"
import script from "../../../scripts/partials/UserAssessmentModal2.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/UserAssessmentModal2.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports